import ArrayClass from './ArrayClass';
import i18n from 'src/i18n';

class UtilSelects {
  constructor(parent_self) {
    this.parent_self = parent_self;
  }

  selectAllFromSelect(model, array_data, scope = null) {
    let is_string = typeof model === 'string' || model instanceof String;
    let if_validation = is_string
      ? eval('this.parent_self.' + model + '.includes(0)')
      : model.includes(0);

    if (if_validation) {
      let maped = array_data.map((item) => {
        return item.id;
      });

      if (is_string) {
        eval(
          'this.parent_self.' +
            model +
            ' = ' +
            '[' +
            ArrayClass.joinSeparateByParam(maped) +
            ']'
        );
        let before_filered = eval('this.parent_self.' + model);
        eval(
          'this.parent_self.' +
            model +
            ' = ' +
            '[' +
            ArrayClass.joinSeparateByParam(before_filered) +
            ']' +
            '.filter((item) => { return item != 0 })'
        );
      } else {
        model = maped.filter((item) => {
          return Number(item) != 0;
        });
        if (scope) {
          scope.row.businesses_id = model;
        }
      }
    }
  }

  selectAllFromSelectSensors(model, array_data, scope = null) {
    let is_string = typeof model === 'string' || model instanceof String;
    let if_validation = is_string
      ? eval('this.parent_self.' + model + '.includes(-1)')
      : model.includes(-1);

    if (if_validation) {
      let maped = array_data.map((item) => {
        return item.code;
      });

      if (is_string) {
        this.parent_self.payload.sensor_codes = [...maped].filter(
          (item) => item != -1
        );
      } else {
        model = maped.filter((item) => {
          return item != -1;
        });
        if (scope) {
          scope.row.businesses_id = model;
        }
      }
    }
  }

  selectAllFromSelectLots($event, model, array_data, scope = null) {
    let is_string = typeof model === 'string' || model instanceof String;
    let if_validation = $event.some(
      (item) => item === i18n.t('cla.utilselects.text1')
    );

    if (if_validation) {
      let maped = array_data.map((item) => {
        return "'" + item.name + "'";
      });

      if (is_string) {
        let filtered = maped.filter(
          (el) => el !== `'${i18n.t('cla.utilselects.text1')}'`
        );
        eval('this.parent_self.' + model + '=' + '[' + filtered + ']');
      }
    }
  }
}

export default UtilSelects;
